var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-error",class:_vm.compact ? 'image-error-compact' : '',attrs:{"title":_vm.text}},[_c('i',{staticClass:"el-icon-picture-outline",class:_vm.compact ? 'font-16' : 'font-24'}),(!_vm.compact)?_c('span',{staticClass:"image-error-text"},[_vm._v(_vm._s(_vm.text))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }